<div class="container lowerMargin">
	<div class="filters">
		<h4>Filtry</h4>
		<app-group-offer-price-filters
			[product]="parameters.product"
			[forceFilters]="{ limit: 9999 }"
			[date_range]="parameters.dateRange"
			[status]="parameters.term_price_status"
			[offerTerm]="offerTerm"
			(selected)="filtersChange($event)"
			[(editable)]="editable"
		></app-group-offer-price-filters>
		<mat-divider></mat-divider>
	</div>
	<div>
		<mat-table #dataTable [dataSource]="matData" matSort matSortDirection="asc">
			<ng-conainer matColumnDef="select">
				<mat-header-cell *matHeaderCellDef>
					<mat-checkbox
						(change)="$event ? toggleAllRows() : null"
						[checked]="selection.hasValue() && isAllSelected()"
						[indeterminate]="selection.hasValue() && !isAllSelected()"
					></mat-checkbox>
				</mat-header-cell>
				<mat-cell *matCellDef="let row">
					<mat-checkbox
						(click)="$event.stopPropagation()"
						(change)="selection.toggle(row)"
						[checked]="selection.isSelected(row)"
						[aria-label]="checkboxLabel(row)"
					></mat-checkbox>
				</mat-cell>
			</ng-conainer>
			<ng-conainer matColumnDef="name">
				<mat-header-cell *matHeaderCellDef mat-sort-header> Nazwa produktu</mat-header-cell>
				<mat-cell *matCellDef="let element">{{ element.product?.name }}</mat-cell>
			</ng-conainer>
			<ng-conainer matColumnDef="date">
				<mat-header-cell *matHeaderCellDef mat-sort-header class="text-center"> Data</mat-header-cell>
				<mat-cell *matCellDef="let element"
					>{{ element.dateRange?.lower }} - {{ element.dateRange?.upper }}</mat-cell
				>
			</ng-conainer>
			<ng-conainer matColumnDef="nights">
				<mat-header-cell mat-sort-header *matHeaderCellDef class="text-center">
					Ilość <br />noclegów</mat-header-cell
				>
				<mat-cell *matCellDef="let element">{{
					countNights(element.dateRange?.lower, element.dateRange?.upper)
				}}</mat-cell>
			</ng-conainer>
			<ng-conainer matColumnDef="board">
				<mat-header-cell *matHeaderCellDef class="text-center">Wyżywienie</mat-header-cell>
				<mat-cell
					[matTooltip]="element.product?.boardTooltip"
					matTooltipPosition="right"
					*matCellDef="let element"
					class="text-center"
					>{{ getBoard(element.product?.board) }}</mat-cell
				>
			</ng-conainer>
			<ng-conainer matColumnDef="catalogPrice">
				<mat-header-cell mat-sort-header *matHeaderCellDef class="text-center"
					>Cena <br />
					katalogowa</mat-header-cell
				>
				<mat-cell *matCellDef="let element">
					<ng-container *ngIf="element.termPrice">
						{{ element.termPrice.price | price }}
						{{ element.termPrice.currency }}
					</ng-container>
				</mat-cell>
			</ng-conainer>
			<ng-conainer matColumnDef="currentPrice">
				<mat-header-cell mat-sort-header *matHeaderCellDef class="text-center"
					>Cena <br />
					aktualna</mat-header-cell
				>
				<mat-cell *matCellDef="let element">
					<ng-container *ngIf="element.termPrice">
						{{ element.termPrice.currentPrice | price }}
						{{ element.termPrice.currency }}
					</ng-container>
				</mat-cell>
			</ng-conainer>
			<ng-container matColumnDef="hourglass">
				<mat-header-cell *matHeaderCellDef class="text-center"></mat-header-cell>
				<mat-cell *matCellDef="let element">
					<i
						matTooltip="Historia cen"
						class="fa-solid fa-hourglass onHover"
						(click)="openPriceHistoryDialog(element)"
						[ngClass]="{ disabled: editable }"
					></i>
				</mat-cell>
			</ng-container>
			<ng-conainer matColumnDef="status">
				<mat-header-cell *matHeaderCellDef class="text-center">Status</mat-header-cell>
				<mat-cell *matCellDef="let element; let i = index">
					<i
						class="fa-solid"
						[ngClass]="{
							'fa-circle-check green': element.termPrice?.status === 'P',
							'fa-circle-xmark red': element.termPrice?.status === 'E',
							'fa-pen yellow': element.termPrice?.status === 'D',
							'fa-clock': element.termPrice?.status === 'W',
						}"
					></i>
				</mat-cell>
			</ng-conainer>

			<ng-container matColumnDef="promotionProcentage">
				<mat-header-cell *matHeaderCellDef class="text-center"
					>Promocja <br />
					%</mat-header-cell
				>
				<mat-cell *matCellDef="let element">
					<i
						*ngIf="element.promotions?.method !== 'amount' && element.promotion"
						class="fa-solid fa-percent"
					></i>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="promotionPrice">
				<mat-header-cell *matHeaderCellDef class="text-center"
					>Promocja <br />
					$</mat-header-cell
				>
				<mat-cell *matCellDef="let element">
					<i
						*ngIf="element.promotions?.method === 'amount' && element.promotion"
						class="fa-solid fa-piggy-bank"
						[matTooltip]="element.promotions?.value"
					></i>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="settings">
				<mat-header-cell *matHeaderCellDef class="text-center">Ustawienia</mat-header-cell>
				<mat-cell *matCellDef="let element" class="text-center">
					<div *ngIf="element.pricePriority === 'T'">
						<i
							class="fa-solid onHover"
							[matTooltip]="element.priceSettingTooltip"
							matTooltipPosition="right"
							(click)="openActivePriceSettingsDialog(element)"
							[ngClass]="{
								'fa-sack-dollar': element.priceSettings?.termPriceSettings,
								'fa-building-columns':
									!element.priceSettings?.termPriceSettings &&
									element.priceSettings?.groupProductPriceSettings,
								'fa-money-bill':
									!element.priceSettings?.termPriceSettings &&
									!element.priceSettings?.groupProductPriceSettings &&
									element.priceSettings?.productPriceSettings,
								disabled: editable,
							}"
						></i>
					</div>
					<div *ngIf="element.pricePriority === 'G' || element.pricePriority === 'P'">
						<i
							class="fa-solid onHover"
							[matTooltip]="element.priceSettingTooltip"
							matTooltipPosition="right"
							(click)="openActivePriceSettingsDialog(element)"
							[ngClass]="{
								'fa-building-columns': element.pricePriority === 'G',
								'fa-money-bill': element.pricePriority === 'P',
								disabled: editable,
							}"
						></i>
					</div>
				</mat-cell>
			</ng-container>
			<ng-container matColumnDef="kind">
				<mat-header-cell *matHeaderCellDef class="text-center">Rodzaj</mat-header-cell>
				<mat-cell *matCellDef="let element" class="text-center">
					<i
						[ngClass]="{
							'fa-bus': element.transportKind === OfferTransportKind.COACH,
							'fa-plane': element.transportKind === OfferTransportKind.PLANE,
						}"
						class="fas"
					></i>
				</mat-cell>
			</ng-container>

			<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
			<mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
		</mat-table>
		<div class="footer d-flex flex-column p-2">
			<div class="d-flex flex-row justify-content-end py-1 px-4">
				<mat-paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 25, 50]" showFirstLastButtons></mat-paginator>
			</div>
			<div class="d-flex flex-row align-items-center justify-content-between w-100 px-4">
				<div class="d-flex align-items-center flex-row w-50 options-form">
					<div class="d-flex align-items-center w-100 px-4">
						<ng-select
							class="select-min-width"
							placeholder="Dla zaznaczonych terminów"
							[disabled]="editable"
							[(ngModel)]="selectedValue"
							(change)="changeOption($event)"
							><ng-option *ngFor="let item of selectedTerms" [value]="item.id">{{
								item.option
							}}</ng-option></ng-select
						>

						<div class="d-flex align-items-center" *ngIf="[1].includes(selectedTerms[selectedTermsId].id)">
							<mat-radio-group [(ngModel)]="selectedTermPriceAction" class="mat-radio-change-price">
								<mat-radio-button *ngFor="let item of termPriceAction" [value]="item.id">{{
									item.name
								}}</mat-radio-button>
							</mat-radio-group>

							<mat-form-field>
								<input
									matInput
									type="number"
									placeholder="Wartość"
									[formControl]="isEmptyForm"
									[(ngModel)]="termPriceValue"
									required
								/>

								<mat-error *ngIf="isEmptyForm.errors?.required">Pole nie może być puste</mat-error>
							</mat-form-field>
						</div>
						<div class="px-4">
							<button
								(click)="checkOption()"
								mat-raised-button
								[disabled]="!optionSelected"
								color="primary"
							>
								Wykonaj
							</button>
						</div>
					</div>
				</div>

				<div class="d-flex align-items-center flex-row w-50 justify-content-end">
					<div class="d-flex align-items-center justify-content-end w-100 px-4">
						<ng-select
							class="w-50"
							[disabled]="editable"
							[(ngModel)]="selectedPriceType"
							placeholder="Zmieniaj cenę"
							><ng-option *ngFor="let item of priceType" [value]="item">{{ item.option }}</ng-option>
						</ng-select>
					</div>
					<div>
						<button
							(click)="openPublicationDialog()"
							[disabled]="editable"
							mat-raised-button
							color="primary"
						>
							Publikuj
						</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
